import "./inputloading.css";
import React from "react";

function InputLoading() {
  return (
    <div className="filter-loading">
      <input />
    </div>
  );
}

export { InputLoading };



// WEBPACK FOOTER //
// ./src/inputloading/inputloading.js